module.exports = __webpack_public_path__ + "static/img/loading.96d0e26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.jpg
// module id = QKtl
// module chunks = 1